<!--
 * @Author: your name
 * @Date: 2022-03-07 10:10:59
 * @LastEditTime: 2022-06-22 16:06:14
 * @LastEditors: zdx 3539255028@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\components\user\UserInfo.vue
-->
<template>
  <div class="user-info">
    <img @click.stop="visible = true" :src="icon || require('@/assets/workbench/user-img.png')" alt="" />
    <a-modal :visible="visible" class="user-info-box" :closable="false" :footer="null" :mask="false" width="135px">
      <div class="user-right">
        <a-upload
          ref="upHead"
          accept=".jpg,.png"
          v-model="fileList"
          :showUploadList="false"
          class="upload"
          :customRequest="_rewriteUpload"
        >
          <div class="user-image">
            <div class="user-image-mask">修改头像</div>
            <img :src="icon || require('@/assets/workbench/user-img.png')" alt="" />
          </div>
        </a-upload>
        <div class="user-info-el nick-name">
          <span v-show="!ifRename">{{ nickName ? nickName : '' }}</span>
          <span v-show="!ifRename" class="iconfont icon-bianji2" @click="_rename"></span>
          <a-input
            v-show="ifRename"
            v-model="nickNameModify"
            @blur="_changeNickName"
            @pressEnter="_changeNickName"
            ref="renameInput"
          />
          <!-- <span v-show="ifRename" class="iconfont icon-correct-bold" @click="_changeNickName"></span>
          <span v-show="ifRename" class="iconfont icon-error-bold" @click="ifRename = false"></span> -->
        </div>
      </div>
      <div class="bottom-operation">
        <span class="set-pwd bottom-operation-item" type="button" @click="_changePwd">
          <span class="iconfont icon-mima"></span>
          修改密码
        </span>
        <span @click="_handleLogout" class="bottom-operation-item">
          <span class="iconfont icon-tuichu"></span>
          退出登录</span
        >
      </div>
    </a-modal>
    <user-password ref="userPassword"></user-password>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import Vue from 'vue'
import { regTestControl } from '@/utils/validate'
import { mapActions } from 'vuex'
import { userManager } from '@/utils/user_manager'
import UserPassword from '@/components/tools/UserPassword'
import { UploadFileService, EN_RESOURCE_CODE } from '@/utils/oss/upload_service.ts'
import { setUserInfo } from '@/api/api'
import { USER_INFO } from '@/store/mutation-types'
import store from '@/store/'
export default {
  components: {
    UserPassword,
  },
  data() {
    return {
      visible: false,
      fileList: [],
      nickName: '',
      nickNameModify: '',
      ifRename: false,
      icon: '',
      username: '',
    }
  },
  mounted() {
    this.initUser()
  },
  methods: {
    ...mapActions(['Logout']),
    async initUser() {
      const { username, realname, avatar } = store.getters.userInfo
      this.nickName = realname
      if (avatar) {
        if (avatar.substr(0, 4) === 'http') {
          this.icon = avatar
        } else {
          this.icon = `${window._CONFIG['ossPathUrl']}${avatar}`
        }
      }
      this.username = username
    },
    _changePwd() {
      this.visible = false
      this.$refs.userPassword.show(this.username)
    },
    async _rewriteUpload(data) {
      try {
        const { fileAddress } = await UploadFileService.uploadFile(data.file, EN_RESOURCE_CODE.USER)
        this.icon = fileAddress
        this._setUserInfo()
      } catch (e) {
        message.error(e.message)
      }
    },
    _cancel() {},
    _handleLogout() {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
              // that.$router.push({ path: '/user/login' })
              // window.location.reload()
              // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
            })
            .catch((err) => {
              that.$message.error({
                title: '错误',
                description: err.message,
              })
            })
        },
        onCancel() {},
      })
    },
    // 点击编辑icon
    _rename() {
      this.ifRename = true
      this.nickNameModify = this.nickName || ''
      this.$nextTick(() => {
        this.$refs.renameInput.focus()
      })
    },
    async _setUserInfo() {
      const { code, result } = await setUserInfo({ realName: this.nickNameModify, avatar: this.icon })
      if (code === 200) {
        message.success('修改成功')
        this.ifRename = false
        this.$store.commit('SET_INFO', result)
        Vue.ls.set(USER_INFO, result, 7 * 24 * 60 * 60 * 1000)
        // userManager.updateUserInfo({ token, user: { realname, username, avatar, id } })
        this.initUser()
      }
    },
    // enter 或者点击√icon
    _changeNickName() {
      if (this.nickName !== this.nickNameModify) {
        if (this.nickNameModify.replaceAll(' ', '') === '') {
          message.warning('名称不能为空')
          this.$nextTick(() => {
            this.$refs.renameInput.focus()
          })
        } else if (!regTestControl(this.nickNameModify)) {
          message.warning('输入内容含有非法字符')
          this.$nextTick(() => {
            this.$refs.renameInput.focus()
          })
        } else {
          this._setUserInfo()
        }
      } else {
        this.ifRename = false
      }
    },
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
